export const errorMessage = {
    computed: {
        errorMessage() {
            return (attribut, error) => {
                if (error.required !== undefined && !error.required)
                    return `Le champ ${attribut} est obligatoire`;
                if (error.minLength !== undefined && !error.minLength) {
                    return `Le champ ${attribut} doit avoir au minimum ${error.$params.minLength.min} caractères`;
                }
                if (error.maxLength !== undefined && !error.maxLength) {
                    return `Le champ ${attribut} doit avoir au maximum ${error.$params.maxLength.max} caractères`;
                }
                if (error.alphaNum !== undefined && !error.alphaNum) {
                    return `Le champ ${attribut} doit contenir que des lettres[A-Z a-z] ou nombres[0-9]`;
                }
                if (error.email !== undefined && !error.email) {
                    return `Veuillez saisir un email valide`;
                }
                if (error.numeric !== undefined && !error.numeric) {
                    return `Le champ ${attribut} doit contenir que des nombres [0-9] sans espaces ou autres caractères`;
                }
                if (error.integer !== undefined && !error.integer) {
                    return `Le champ ${attribut} doit contenir que des nombres entiers sans virgules`;
                }
                if (error.decimal !== undefined && !error.decimal) {
                    return `Le champ ${attribut} doit contenir que des nombres`;
                }
                if (error.minValue !== undefined && !error.minValue) {
                    return `Le champ ${attribut} doit avoir une valeur plus grande que ${error.$params.minValue.min}`;
                }
                if (error.maxValue !== undefined && !error.maxValue) {
                    return `Le champ ${attribut} doit avoir une valeur plus petite que ${error.$params.maxValue.max}`;
                }
            };
        }
    }
};
